export default __webpack_public_path__ + "img/e7560dcf5b6cf8fe7819ad488b3ead05.svg";